// @flow

import * as React from "react";
import { getMembershipDateString } from "../../utils/date";
import TextButton from "../atoms/TextButton";

type PropsType = {
    order: any,
    setActiveOrder: Function,
};

const PurchaseLineItem = (props: PropsType): React.Node => {
    return (
        <div className="row purchase-line-item">
            <div className="col-xs-12 col-md-4">
                <div className="purchase-line-item__left-content">
                    <div className="purchase-line-item__date">
                        {getMembershipDateString(
                            props.order.date_created,
                            "yyyy-MM-dd'T'HH:mm:ss"
                        )}
                    </div>
                    <div>
                        {props.order.line_items.map(product => {
                            return (
                                <div
                                    key={product.id}
                                    className="purchase-line-item__product-detail"
                                >
                                    {product.quantity}
                                    {" x "}
                                    {product.name}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="col-xs-12 col-md-6">
                <div className="purchase-line-item__order-detail">
                    <div className="purchase-line-item__order-detail__col purchase-line-item__order-detail__id">
                        <div className="purchase-line-item__order-detail__title">
                            Order number
                        </div>
                        <div className="purchase-line-item__order-detail__body">
                            #{props.order.id}
                        </div>
                    </div>
                    <div className="purchase-line-item__order-detail__col purchase-line-item__order-detail__status">
                        <div className="purchase-line-item__order-detail__title">
                            Status
                        </div>
                        <div className="purchase-line-item__order-detail__status__data">
                            {props.order.status}
                        </div>
                    </div>
                    <div className="purchase-line-item__order-detail__col purchase-line-item__order-detail__price">
                        <div className="purchase-line-item__order-detail__title">
                            Total
                        </div>
                        <div className="purchase-line-item__order-detail__id">
                            ${props.order.total}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xs-12 col-md-2">
                <div className="purchase-line-item__cta">
                    <TextButton onClick={props.setActiveOrder}>
                        Order details
                    </TextButton>
                </div>
            </div>
        </div>
    );
};

export default PurchaseLineItem;
